// @flow

export const RATING_TYPES = {
  general: 1,
  uk: 2,
  provider: 3,
}
